import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { FiMonitor } from "react-icons/fi";

export default function HRMSUsageTrend() {
  const [range, setRange] = useState("1W");
  const [dropdown, setDropdown] = useState(false);
  const [selected, setSelected] = useState("Today");

  const dataSets = {
    "1H": [1200, 2000, 1500, 3000, 2500],
    "1D": [1500, 2200, 1800, 2600, 2100],
    "1W": [1200, 4800, 4800, 2000, 6000, 6000, 8000],
    "1M": [2000, 3000, 4000, 5000, 7000],
  };

  const categories = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  /* MAIN GRAPH */
  const mainChart = {
    options: {
      chart: {
        type: "area",
        toolbar: { show: false },
      },

      stroke: {
        curve: "smooth",
        width: 3,
        colors: ["#2c5c5e"],
      },

      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.35,
          opacityTo: 0.05,
        },
      },

      grid: {
        borderColor: "#e9ecef",
        strokeDashArray: 5,
      },

      xaxis: {
        categories,
        labels: {
          style: {
            colors: "#6c757d",
            fontSize: "12px",
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },

      yaxis: {
        min: 0,
        max: 8000,
        tickAmount: 4,
        labels: {
          formatter: (val) => `${val / 1000}K`,
          style: {
            colors: "#6c757d",
            fontSize: "12px",
          },
        },
      },

      markers: {
        size: 5,
        colors: ["#2c5c5e"],
        strokeColors: "#fff",
        strokeWidth: 2,
        hover: { size: 7 },
      },

      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex }) {
          const value = series[seriesIndex][dataPointIndex];

          return `
            <div style="
              background:#e9ecef;
              padding:10px 14px;
              border-radius:10px;
              box-shadow:0 4px 12px rgba(0,0,0,0.1);
              font-size:13px;
            ">
              <div style="color:#555;margin-bottom:4px;">
                ${dataPointIndex + 1}
              </div>

              <div style="display:flex;align-items:center;gap:6px;">
                <span style="
                  width:10px;
                  height:10px;
                  background:#2c5c5e;
                  border-radius:50%;
                  display:inline-block;
                "></span>

                performance: <b>${value}</b>
              </div>
            </div>
          `;
        },
      },

      dataLabels: {
        enabled: false,
      },
    },

    series: [
      {
        data: dataSets[range],
      },
    ],
  };

  /* MINI GRAPH */
 const miniChart = (color) => ({
  chart: {
    type: "line",
    sparkline: { enabled: true },
  },

  stroke: {
    curve: "straight",
    width: 2.5,
    colors: [color],
  },

  markers: {
    size: 4,
    colors: [color],
    strokeColors: "#fff",
    strokeWidth: 2,
    hover: { size: 6 },
  },

  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex }) {
      const value = series[seriesIndex][dataPointIndex];

      return `
        <div style="
          background:#e9ecef;
          border-radius:10px;
          overflow:hidden;
          box-shadow:0 6px 16px rgba(0,0,0,0.15);
          font-size:13px;
        ">
          <div style="
            padding:8px 12px;
            border-bottom:1px solid #ddd;
            color:#555;
          ">
            ${dataPointIndex + 1}
          </div>

          <div style="
            padding:10px 12px;
            display:flex;
            align-items:center;
            gap:6px;
          ">
            <span style="
              width:10px;
              height:10px;
              background:${color};
              border-radius:50%;
              display:inline-block;
            "></span>

            performance: <b>${value}</b>
          </div>
        </div>
      `;
    },
  },
});

  return (
    <Card style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.title}>
            <strong  ><FiMonitor style={styles.icon} />
            HRMS Usage Trend</strong>
          </div>

          <div style={styles.filters}>
            {["1H", "1D", "1W", "1M"].map((f) => (
              <button
                key={f}
                onClick={() => setRange(f)}
                style={{
                  ...styles.filterBtn,
                  background: range === f ? "#0d3b3e" : "#f1f1f1",
                  color: range === f ? "#fff" : "#333",
                }}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* GRAPH */}
        <Chart
          options={mainChart.options}
          series={mainChart.series}
          type="area"
          height={260}
        />

        {/* SECURITY HEADER */}
        <div style={styles.secHeader}>
          <strong style={{ fontWeight: 600 ,fontSize:"15px"}}>Security & Compliance</strong>

          <div style={{ position: "relative" }}>
            <button 
              style={styles.dropdownBtn}
              onClick={() => setDropdown(!dropdown)}
            >
            {selected}
            </button>

            {dropdown && (
              <div style={styles.dropdown}>
                {["Today", "Weekly", "Monthly"].map((d) => (
                  <div
                    key={d}
                    style={styles.dropdownItem}
                    onClick={() => {
                      setSelected(d);
                      setDropdown(false);
                    }}
                  >
                    {d}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* STATS */}
        <div style={styles.stats}>
          <Stat value="47" title="Failed Logins" sub="Last 24h" color="#ff3b3b" data={[20,40,25,35,28,33,29]} miniChart={miniChart} />
          <Stat value="12" title="Suspicious Alerts" sub="Active" color="#2c5c5e" data={[10,15,12,18,14,20,16]} miniChart={miniChart} />
          <Stat value="27" title="Blocked IPs" sub="Currently blocked" color="#ff4fa3" data={[8,6,7,9,5,10,8]} miniChart={miniChart} />
        </div>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
        @media (max-width:768px){
          .apexcharts-canvas {
            width:100% !important;
          }
        }
      `}</style>
    </Card>
  );
}

/* STAT */
const Stat = ({ value, title, sub, color, data, miniChart }) => (
  <div style={styles.statRow}>
    
    {/* LEFT SIDE */}
    <div style={styles.left}>
      <h2 style={styles.value}>{value}</h2>

      <div style={styles.textBlock}>
        <div
          style={{
            ...styles.verticalLine,
            background: color,
          }}
        />

        <div>
          <div style={styles.title}>{title}</div>
          <div style={styles.sub}>{sub}</div>
        </div>
      </div>
    </div>

    {/* RIGHT GRAPH */}
    <Chart
      options={miniChart(color)}
      series={[{ data }]}
      type="line"
      height={60}
      width={120}
    />
  </div>
);
/* STYLES */
const styles = {
  card: {
    borderRadius: 5,
    padding: 16,
    border: "2px solid #eee",
  },


header: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 10,
  flexWrap: "wrap",            // ✅ allows wrapping when needed
  gap: 10,
},
title: {
  fontWeight: 500,
  fontSize: 15,
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexWrap: "nowrap",          // ❌ prevent breaking into 3 lines
},

icon: {
  color: "#f2540b",
  flexShrink: 0               // ✅ icon should not shrink
},

  icon: { color: "#f2540b" },

  filters: { display: "flex", gap: 6 },

  filterBtn: {
    border: "none",
    padding: "5px 10px",
    borderRadius: 6,
    fontSize: 12,
    cursor: "pointer",
  },

 secHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 20,
  },

  dropdownBtn: {
    border: "1px solid #e5e7eb",
    padding: "6px 12px",
    borderRadius: 8,
    background: "#fff",
    fontSize: 13,
    zindex:"100"
  },

dropdown: {
  position: "absolute",
  top: 42,
  right: 0,
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
  overflow: "hidden",
  minWidth: "160px",
  padding: "8px 0",
  zIndex: 1000 //
},

  dropdownItem: {
    padding: "12px 18px",
    fontSize: 14,
    cursor: "pointer",
     zIndex: 1000 //


  },

  stats: {
    marginTop: 15,
    display: "flex",
    flexDirection: "column",
    gap: 22,
  },


    statRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },

  value: {
    margin: 0,
    fontWeight: 700,
    fontSize: 28,
    color: "#1f2937",
  },


  statTitle: {
    margin: "4px 0",
    fontWeight: 500,
  },

 textBlock: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  verticalLine: {
    width: 3,
    height: 40,
    borderRadius: 2,
  },

  title: {
    fontWeight: 600,
    fontSize: 14,
  },

  sub: {
    fontSize: 12,
    color: "#6c757d",
    marginTop: 2,
  },
};